import {createSlice} from '@reduxjs/toolkit';
import {BuildingsSliceState} from './types';
import {loadBuildings} from './actions';
import {buildingsAdapter} from './adapters';

const initialState = <BuildingsSliceState>buildingsAdapter.getInitialState({
  loadingStatus: 'NotLoaded',
  openingDaysExceptions: [],
  denormalized: [],
});

const slice = createSlice({
  name: 'buildings',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadBuildings.pending, (state) => {
        state.loadingStatus = 'Loading';
      })
      .addCase(loadBuildings.fulfilled, (state, action) => {
        const {buildings} = action.payload;

        buildingsAdapter.setAll(state, buildings);

        state.denormalized = action.payload.denormalized;
        state.loadingStatus = 'Loaded';
      })
      .addCase(loadBuildings.rejected, (state) => {
        state.loadingStatus = 'Failed';
      });
  },
});

export const {reducer: buildingsReducer} = slice;
